import { render, staticRenderFns } from "./alerts-messages.vue?vue&type=template&id=5072764c&scoped=true&lang=pug&"
import script from "./alerts-messages.vue?vue&type=script&lang=ts&"
export * from "./alerts-messages.vue?vue&type=script&lang=ts&"
import style0 from "./alerts-messages.vue?vue&type=style&index=0&id=5072764c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5072764c",
  null
  
)

export default component.exports